import React from "react";
import {Select} from "antd";

const {Option} = Select;

export const doPosBasic = [  // đã dịch

    {
        "column": "POS_TONG_DT_GOP_CTY",
        "customFormula": false,
        "name": "Tổng doanh thu gộp của công ty",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_DT_THUAN_CTY",
        "customFormula": false,
        "name": "Tổng doanh thu thuần của công ty",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_LN_GOP_CTY",
        "customFormula": false,
        "name": "Tổng lợi nhuận gộp của công ty",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_DT_GOP_NV",
        "customFormula": false,
        "name": "Tổng doanh thu gộp của nhân viên",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_DT_THUAN_NV",
        "customFormula": false,
        "name": "Tổng doanh thu thuần của nhân viên",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_TIEN_HOA_HONG_NV",
        "customFormula": false,
        "name": "Tổng tiền hoa hồng của nhân viên",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_SO_SP_BAN_RA_NV",
        "customFormula": false,
        "name": "Tổng số sản phẩm bán ra",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_SO_SP_HOAN_THANH_NV",
        "customFormula": false,
        "name": "Tổng số sản phẩm đã hoàn thành",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_SO_DH_BAN_RA_NV",
        "customFormula": false,
        "name": "Tổng số đơn hàng bán ra",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_SO_DH_HOAN_THANH_NV",
        "customFormula": false,
        "name": "Tổng số đơn hàng hoàn thành",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_SO_KH_MOI_NV",
        "customFormula": false,
        "name": "Tổng số khách hàng mới",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_TONG_SO_KH_MOI_HOAN_THANH_NV",
        "customFormula": false,
        "name": "Tổng số khách hàng mới hoàn thành",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },
    {
        "column": "POS_SALE_PLAN_ACHIEVEMENT",
        "customFormula": false,
        "name": "Tỷ lệ hoàn thành Sale Plan",
        "defaultValue": "",
        "note": "",
        "type": "doPos",
        "value": ""
    },

];

export const generateVariantsPosReference = (t) => {
    const suffixes = [ "_THANG", "_QUY","_NAM",];
    const newData = [];

    doPosBasic.forEach((item) => {

        newData.push({
            ...item,
            name : t("layout.keyword." + item.column)
        })
        suffixes.forEach((suffix) => {
            const newItem = {
                ...item,
                column: `${item.column}${suffix}`,
                name: t("layout.keyword." + item.column) +
                    `${suffix === "_NAM" ?
                        t("layout.keyword.currentYear")
                        : suffix === "_THANG" ?
                            t("layout.keyword.currentMonth")
                            :  t("layout.keyword.currentQuarter")
                    }`

            };
            newData.push(newItem);
        });
    });

    return [ ...newData];
}

export const doPosReference = (t) => generateVariantsPosReference(t)


const doWorkStatusLabel = (t) => { return [
    {key : 'pending', label : t("common.pending")},
    {key : 'doing', label : t("common.doing")},
    {key : 'approved', label : t("common.completed")},
    {key : 'inactive', label : t("common.inactive")},
    {key : 'denied', label  : t("common.denied")}
]}

export const doWorkReference = (t) => {
    return  [
    {
        column: "doWork_task_completed",
        customFormula: false,
        name: t("layout.keyword.doWork_task_completed"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_task_late",
        customFormula: false,
        name: t("layout.keyword.doWork_task_late"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_task_ontime",
        customFormula: false,
        name:  t("layout.keyword.doWork_task_ontime"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_task_early",
        customFormula: false,
        name:  t("layout.keyword.doWork_task_early"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_task_pending",
        customFormula: false,
        name:  t("layout.keyword.doWork_task_pending"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_task_in_progress",
        customFormula: false,
        name:  t("layout.keyword.doWork_task_in_progress"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_task_in_overdue_incomplete",
        customFormula: false,
        name:  t("layout.keyword.doWork_task_in_overdue_incomplete"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_product_target",
        customFormula: false,
        name:  t("layout.keyword.doWork_product_target"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_product_quantity",
        customFormula: false,
        name:  t("layout.keyword.doWork_product_quantity"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    },
    {
        column: "doWork_product_remaining",
        customFormula: false,
        name:  t("layout.keyword.doWork_product_remaining"),
        defaultValue: "",
        note: "",
        type: "doWork",
        value: "",
    }
]};


export function mapperKeyWord(dataKeyWord) {
    return dataKeyWord?.map((item) => {
        return (
            <Option title={item.name} key={item.column} value={item.column}>
                {item.name} <br/>
                {item.column}
            </Option>
        )
    })
}

export function getKeyWorkEspecially(dataKeyWorkEspecially) {
    return dataKeyWorkEspecially
        ?.filter(item => item.keyColumn === "SALARY_END")
        ?.map((item) => {
            return (
                <Option enabled={item.keyColumn === "SALARY_END"}
                        title={item.describe} style={{color: 'orange'}}
                        key={item.keyColumn}
                        value={item.keyColumn}>
                    {item.describe} <br/>
                    {item.keyColumn}
                </Option>
            )
        })
}

export function getDataReference(t) {
    return doWorkReference(t)?.map(item => {
        return (
            <Option title={item.name} style={{color: '#FC9034'}}  key={item.column} value={item.column}>
                {item.name} <br/>
                {item.column}
            </Option>
        )
    })
}

export function getTaskLabelReference(dataTaskLabel) {
    return dataTaskLabel?.map(item => {
        return (
            <Option title={item.name}  style={{color: '#FC9034'}} key={item.column} value={item.column}>
                {item.name} <br/>
                {item.column}
            </Option>
        )
    })
}

export function getDoPosReference(t){
    return doPosReference(t)?.map(item => {
        return (
            <Option title={item.name} style={{color: '#51479d'}}  key={item.column} value={item.column}>
                {item.name} <br/>
                {item.column}
            </Option>
        )
    })
}

export  function mapTaskLabel(res,t) {
    const totalLabel = []

    res?.items?.map((item) => {
        const buildName = t("layout.keyword.totalTaskLabel",{ name : item?.name });
        const buildKey = `doWork_label_${normalizeString(item?.name)}_${item?.id}`;
        totalLabel.push({
            ...item,
            column: buildKey,
            customFormula: false,
            defaultValue: "",
            note: "",
            type: "doWork",
            value: "",
            name: buildName,
            key: buildKey,
        })

        doWorkStatusLabel(t).forEach(status => {
            const buildStatusName = t("layout.keyword.totalTaskLabelAndStatus",{ name : item?.name ,status : status.label});
            const buildStatusKey = `doWork_label_status_${normalizeString(item?.name)}_${status.key}_${item?.id}`;
            totalLabel.push({
                ...item,
                column: buildStatusKey,
                customFormula: false,
                defaultValue: "",
                note: "",
                type: "doWork",
                value: "",
                name: buildStatusName,
                key: buildStatusKey,
            })
        })

    });

    return totalLabel;
}

function normalizeString(input) {
    const removeDiacritics = (str) =>
        str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");

    let normalized = removeDiacritics(input);

    normalized = normalized.trim();

    normalized = normalized.replace(/[^A-Za-z0-9_]/g, "_");

    normalized = normalized.replace(/_+/g, "_");

    return normalized;
}